import { FormContent } from 'components';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(FormContent)(({ theme }) => ({
  marginTop: 0,
  [theme.breakpoints.down('mobile')]: {
    marginTop: 0,
  },
}));

export const OnboardingHeaderStyled = styled('div')(({ theme }) => ({
  marginTop: 48,
  [theme.breakpoints.down('mobile')]: {
    marginTop: 32,
  },
  width: '100%',

  '.onboardingLayout-progressBar': {
    width: '100%',
    maxWidth: 1100,
    margin: '0 auto',
    marginBottom: 45,
    [theme.breakpoints.down('mobile')]: {
      marginBottom: 32,
    },
  },
}));
